import React, {useEffect, useState} from "react";
import SettingsContext from "./SettingsContext";
import axios from "axios";


export default function SettingsProvider(
    {source_id = undefined, settings_uri = undefined, language = undefined, children}) {
    const [settings, setSettings] = useState({settings: {}, loading: true})


    useEffect(() => {
        if(!settings_uri) {
            console.error('MISCONFIGURED: data-settings_uri param is missing')
            // TODO: error handling
            return;
        }

        axios.get(settings_uri, {params: {language: language, source_id: source_id}}).then((resp) => {
            if (resp.status === 200) {
                setSettings(settings => ({...settings, settings: resp.data, loading: false}))
            } else {
                // TODO: error handling
                console.error(resp.status)
            }
        }).catch((e) => {
            console.error(e.message)
        })
    }, [])

    return (
        !settings.loading ?
            <SettingsContext.Provider value={settings.settings}>
                {children}
            </SettingsContext.Provider> : <div/>
    )
}